import { render, staticRenderFns } from "./otherTables.vue?vue&type=template&id=aaadcadc&scoped=true&"
import script from "./otherTables.vue?vue&type=script&lang=js&"
export * from "./otherTables.vue?vue&type=script&lang=js&"
import style0 from "./otherTables.vue?vue&type=style&index=0&id=aaadcadc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaadcadc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
